import { usePlanStockTarget as useStockTarget } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-target/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanStockTarget = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { stockTypeTerm, stockTypeTarget, maxDailyStockNum } = viewModel;

	return useStockTarget({ stockTypeTerm, stockTypeTarget, maxDailyStockNum, onSetViewModel });
};
